<template>

	<div>

		<!-- Footer -->
		<footer class="footer">
			<div class="container">
				<div class="copyright">
					© SANGSANGFLEX. All Rights Reserved.
				</div>
				<ul class="fnb">
					<li><a href="/app/statics/introduce">상상플렉스 소개</a></li>
					<li><a href="/app/statics/termsofservice">서비스 약관</a></li>
					<li><a href="/app/statics/privacypolicy">개인정보처리방침</a></li>
				</ul>
			</div>
		</footer>

		<!-- Quick Menu -->
		<div class="quick_menu">
			<button type="button" class="btn_inquiry" data-toggle="modal" data-target="#inquiry" >
				<img src="/ssflex_cs1/assets/img/common/ico/ico_chat_w.svg" alt="">
				<span>1:1 문의</span>
			</button>
		</div>

		<!-- 1:1 Inquiry -->
		<div class="inquiry modal fade" id="inquiry" tabindex="-1" aria-labelledby="inquiry" aria-hidden="true" data-backdrop="false">
			<div class="modal-dialog modal-lg modal-dialog-centered">

				<div class="modal-content">
					<form @submit.prevent="setBoard">
						<div class="modal-header">
							<h2 class="modal-title">1:1 문의하기</h2>
						</div>
						<div class="modal-body">
							<div class="form_row">
								<label for="inquiry_type">문의 유형</label>
								<select id="qna-type" class="slt" v-model="boardVO.cateCode" required="required">
									<option value="">유형을 선택해 주세요.</option>
									<option v-for="(item, index) in boardInfoVO.cateList" :value="item.code">{{ item.codeName }}</option>
								</select>
							</div>
							<div class="form_row">
								<label for="inquiry_title">문의 제목</label>
								<input type="text" id="inquiry_title" class="inp" v-model="boardVO.title" placeholder="제목을 입력해 주세요." required="required">
							</div>
							<div class="form_row">
								<label for="inquiry_mail">이메일</label>
								<input type="email" id="inquiry_mail" class="inp" v-model="boardVO.receiver" placeholder="답변 받을 메일을 입력해 주세요." required="required">
							</div>
							<div class="form_row">
								<label for="inquiry_content">문의 내용</label>
								<textarea type="text" id="inquiry_content" class="tta" v-model="boardVO.contentText" placeholder="내용을 입력해 주세요." required="required"></textarea>
							</div>
						</div>
						<div class="modal-footer">
							<button type="submit" class="btn btn-dark btn-lg">문의하기</button>
						</div>
						<button type="button" class="btn_close" data-dismiss="modal" aria-label="Close">
							<img src="/ssflex_cs1/assets/img/common/ico/ico_close.svg" alt="닫기">
						</button>
					</form>
				</div>
			</div>
		</div>

		<div class="dim"></div>

	</div>


</template>

<script>
import $ from 'jquery'

export default {
	name: "cs1Footer",
	data() {


		return {
			coInfoVO: new this.CoInfo(),

			boardKey: "site_qna",
			boardInfoVO: new this.BoardInfoVO(),
			boardVO: new this.BoardVO(this.getSessionProc()),
		}
	},
	created() {

		this.getCompanyInfo();
		this.getBoardInfo();
	},
	mounted() {

	},
	updated() {

	},
	methods: {
		snsOpen(url) {
			const temp = {
				isCloseBTN : "Y",
				url: url,
			}
			this.appOpen( temp );
		},

		getCompanyInfo () {

			this.axiosCaller.get( this, this.APIs.CO_INFO + "/" + this.webUtils.getSubdomain(), {}, (res) => {
				const result = res.data
				if ( result.status === "ok" ) {
					this.coInfoVO = result.coInfoVO
				} else {
					console.log( result.msg )
				}
			})
		},


		getBoardInfo () {

			this.axiosCaller.get( this, this.APIs.BOARDS + "/getBoardInfo", {
				boardKey: this.boardKey
			}, (res) => {
				var result = res.data
				if ( result.status === "ok" ) {
					this.boardInfoVO = result.boardInfoVO
				}
			});
		},


		setBoard(e) {

			e.preventDefault()

			const self = this
			this.boardVO.boardKey = this.boardKey
			this.boardVO.contentHtml = this.boardVO.contentText
			this.boardVO.writerKey = this.getLoginId()
			if ( this.isLogin() ) {
				this.boardVO.writer = this.getSessionProc().userName
			} else {
				this.boardVO.writer = this.getLoginId()
			}

			// 문의 메일 발송
			this.boardVO.isSendMail = true

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARDS + "/setBoardOne", this.boardVO, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				console.log( result )
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "문의 내용이 등록되었습니다.", "success", 800)
					this.boardVO = new this.BoardVO();
					$('#inquiry').modal('hide')
				}
			}, (err) => {
				this.$eventBus.$emit("doneProgress")
				const msg = err?.response?.data?.msg || "요청이 너무 많습니다. 잠시 후 다시 시도해주세요."
				this.swalUtils.gritter("error", msg, "error", 3000)
			})

		},


	},
}
</script>

<style scoped>

</style>
